export const keysEqual = (objA, objB) => {
    if (objA === objB) return true;
    if (!objA || !objB) return false;
    
    const keysA = Object.keys(objA);
    const keysB = Object.keys(objB);
    
    if (keysA.length !== keysB.length) return false;
    
    // Check if all keys match
    for (let key of keysA) {
        if (!keysB.includes(key)) return false;
        
        // For chair objects, do a shallow comparison of properties
        const valA = objA[key];
        const valB = objB[key];
        
        if (valA === valB) continue; // Same reference
        
        // If values are objects, do shallow comparison
        if (valA && typeof valA === 'object' && valB && typeof valB === 'object') {
            const valAKeys = Object.keys(valA);
            const valBKeys = Object.keys(valB);
            
            if (valAKeys.length !== valBKeys.length) return false;
            
            for (let prop of valAKeys) {
                if (valA[prop] !== valB[prop]) return false;
            }
        } else {
            return false; // Different primitive values
        }
    }
    
    return true;
};
